import React from 'react';
import PropTypes from 'prop-types';
import { IconBadge } from '../common/designSystem';

/**
 * Card-shaped navigation tile — same footprint as StatCard so it sits in a
 * metric row without breaking the grid, but a dashed border marks it as an
 * action rather than a number.
 */
const ActionCard = ({ icon, title, label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="w-full h-full text-left rounded-input border-[1.5px] border-dashed border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder py-3 px-[19px] transition-colors hover:border-shoorah-active focus:outline-none focus-visible:ring-2 focus-visible:ring-shoorah-active"
  >
    <div className="flex items-center gap-4">
      <IconBadge src={icon} />
      <div className="min-w-0">
        <p className="text-[13px] text-gray-500 dark:text-shoorah-darkBg truncate">{title}</p>
        <p className="mt-0.5 text-[16px] leading-tight font-semibold text-shoorah-btn dark:text-white truncate">
          {label}
        </p>
      </div>
    </div>
  </button>
);

ActionCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ActionCard;
